export enum RR_TABLE_ACTION_TYPE {
  ADD,
  EDIT,
  DELETE,
  REFRESH,
  EXCEL,
  DOWNLOAD,
  REVISION,
  GRAPH,
  LIGHTBOX,
  CUSTOM,
}
